export const StoreKey = 'entityFactory';

export type RequestType = 'create' | 'fetch' | 'fetchAll' | 'update' | 'delete';

export type RequestEvent = 'start' | 'success' | 'failed' | 'aborted';

export type RequestMethod = 'GET' | 'POST' | 'DELETE';

export type InternalAction = 'save';
